import {WorkingTimeCalculations} from '../../interfaces/time-tracking/working-time-calculations';


export class WorkingTimeCalculationsFactory {
  public static new(): WorkingTimeCalculations {
    return new class implements WorkingTimeCalculations {
      workingTime: number = 0;
      workingTimeExtrapolated: number = 0;
      plannedWorkingTime: number = 0;
      plannedWorkingTimeDifference: number = 0;
      workingTimeExtrapolatedDifference: number = 0;
      totalWorkingTime: number = 0;
    };
  }
}